import { Component, OnInit } from '@angular/core';
import { ShowBigComponent } from '../../components/show-big/show-big.component';

import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-shows',
  imports: [ShowBigComponent],
  templateUrl: './shows.component.html',
  styleUrl: './shows.component.scss',
})
export class ShowsComponent implements OnInit {
  shows: any[] = [];
  loading = false;
  error: string | null = null;

  constructor(private api: ApiService) {}

  ngOnInit(): void {
    this.loadShows();
  }

  loadShows(): void {
    this.loading = true;
    this.error = null;
    this.api.get<any[]>('/shows/shows').subscribe({
      next: (data) => {
        //sort data by date
        data.sort(
          (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
        );
        this.shows = data ?? [];
        this.loading = false;
      },
      error: (err) => {
        console.error('Failed to load shows', err);
        this.error = 'Failed to load shows';
        this.loading = false;
      },
    });
  }
}
